export type ReimbursementTypeOption =
| 'hsa'
| 'ichra'

interface ReimbursementInput {
  amount: string
  transaction_date: string
  purpose: string
}

export interface MemberReimbursementFormInput extends ReimbursementInput {
  checkbox_one: boolean
  checkbox_two: boolean
  checkbox_three: boolean
  member_description: string
  receipts: File[]
  type: 'ICHRA'
}

export interface AdminReimbursementFormInput extends ReimbursementInput {
  reason?: string
  approved: boolean
  insurance_enrollment_id?: string
  note?: string
  id: string
}

export interface PurposeOption {
  label: string
  value: string
}

export interface DropdownOption {
  label: string
  value: string
}

export interface EnrollmentCostOfCoverage {
  currency: string
  formatted_amount: string
  subunits: number
}

export interface EnrollmentPayments {
  currency: string
  formatted_amount: string
  subunits: number
}

export interface Enrollment {
  id: string
  title: string
  category: string
  monthly_premium: string
  start_date: string
  end_of_coverage: string
  cost_of_coverage: EnrollmentCostOfCoverage
  enrollment_payments_total: EnrollmentPayments
  reimbursement_only_at: string
}

export interface EnrollmentCoverageWithQmeReimbursementStatus {
  start_date: string
  end_date: string
  has_completed_qme_reimbursement: boolean
}

export const ReimbursementPurpose = {
  PREMIUM: 'premium',
  QUALIFIED_MEDICAL_EXPENSE: 'qme'
}

export const RejectionReasons = {
  QME_INELIGIBLE: 'qme_ineligible',
  DUPLICATE: 'duplicate',
  OUTSIDE_COVERAGE_WINDOW: 'outside_coverage_window',
  QME_INELIGIBLE_NEED_LMN: 'qme_ineligible_need_lmn',
  OTHER: 'other',
}
